import React, { useEffect, useState, useRef } from 'react'
import Form from 'react-bootstrap/Form';
import '../assets/css/TextBoxOTPControl.css';

export default function TextBoxOTPControl(props) {

    const [code, setCode] = useState(() =>
        Array(props.LabelCount).fill("")
    );

    const [hasError, setHasError] = useState(false);

    // Create refs ARRAY only once
    const inputs = useRef([]);


    if (inputs.current.length === 0) {
        inputs.current = Array(props.LabelCount)
            .fill()
            .map(() => React.createRef());
    }
    // Focus the first input on initial render
    useEffect(() => {
        inputs.current[0]?.current?.focus();
    }, []);
    useEffect(() => {
        const full = code.join("");
        if (full.length === props.LabelCount && props.onChange) {
            props.onChange(full);
        }
    }, [code, props.LabelCount, props.onChange]);


    // --- Handlers -----------------------------------------------

    const processInput = (e, slot) => {
        if (!/^[0-9]$/.test(e.key)) return;

        e.preventDefault(); // <-- 🚀 Prevents the "2" from overwriting "1"
        setHasError(false);

        const newCode = [...code];
        newCode[slot] = e.key;

        setCode(newCode);

        if (slot < props.LabelCount - 1) {
            inputs.current[slot + 1].current?.focus();
        }

        // if (newCode.join("").length === props.LabelCount && props.onChange)
        //     props.onChange(newCode.join(""));
    };

    const onKeyUp = (e, slot) => {
        if (e.key === "Backspace") {
            const newCode = [...code];
            newCode[slot] = "";
            setCode(newCode);

            if (slot > 0) {
                inputs.current[slot - 1].current?.focus();
            }
        }
    };

    const onKeyPressed = (e) => {
        if (e.charCode === 13 && props.onEnterPressed)
            props.onEnterPressed();
    };


    // --- RENDER -------------------------------------------------

    return (
        <div>
            <Form.Group className="mb-3">


                <Form.Label className='w-100 text-center fw-bold '>
                    {"کد ارسال شده از طریق پیامک را وارد نمایید"}

                </Form.Label>


                <div className={`code-inputs ${hasError ? "code-inputs-invaliddata-bgcolor" : "code-inputs-bgcolor"}`}
                    style={props.inputsDivStyle || {}}
                >
                    {code.map((num, idx) => (
                        <input
                            key={idx}
                            type="text"
                            maxLength={1}
                            inputMode="numeric"
                            value={num}
                            onChange={() => { }}
                            className={`otp-input ${num !== "" ? "filled" : ""}`}
                            onKeyDown={(e) => processInput(e, idx)}
                            onKeyUp={(e) => onKeyUp(e, idx)}
                            onKeyPress={onKeyPressed}
                            ref={inputs.current[idx]}
                        />
                    ))}
                </div>

            </Form.Group>
        </div>
    );
}